/* eslint-disable max-len */

import { PureComponent } from 'react';

import {NotificationIconComponentProps} from 'Component/NotificationIcon/NotificationIconComponent.type';
import {NotificationType} from 'Store/Notification/Notification.type';
import { ReactElement } from 'Type/Common.type';

/** @namespace Steinkrueger/Component/NotificationIcon/Component */
export class NotificationIconComponent extends PureComponent<NotificationIconComponentProps> {
    renderSuccess(): ReactElement {
        return (
            <svg
              block="NotificationIcon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path
                  d="M10 0.25C8.07164 0.25 6.18657 0.821828 4.58319 1.89317C2.97982 2.96451 1.73013
                    4.48726 0.992179 6.26884C0.254225 8.05042 0.061142 10.0108 0.437348 11.9021C0.813554
                    13.7934 1.74215 15.5307 3.10571 16.8943C4.46928 18.2579 6.20656 19.1865 8.09787
                    19.5627C9.98919 19.9389 11.9496 19.7458 13.7312 19.0078C15.5127 18.2699 17.0355
                    17.0202 18.1068 15.4168C19.1782 13.8134 19.75 11.9284 19.75 10C19.7473 7.41498
                    18.7192 4.93661 16.8913 3.10872C15.0634 1.28084 12.585 0.25273 10 0.25ZM14.2806
                    8.28063L9.03063 13.5306C8.96097 13.6004 8.87826 13.6557 8.78721 13.6934C8.69616
                    13.7312 8.59857 13.7506 8.5 13.7506C8.40144 13.7506 8.30385 13.7312 8.2128
                    13.6934C8.12175 13.6557 8.03903 13.6004 7.96938 13.5306L5.71938 11.2806C5.57865
                    11.1399 5.49959 10.949 5.49959 10.75C5.49959 10.551 5.57865 10.3601 5.71938
                    10.2194C5.86011 10.0786 6.05098 9.99958 6.25 9.99958C6.44903 9.99958 6.6399
                    10.0786 6.78063 10.2194L8.5 11.9397L13.2194 7.21937C13.2891 7.14969 13.3718
                    7.09442 13.4628 7.0567C13.5539 7.01899 13.6515 6.99958 13.75 6.99958C13.8486
                    6.99958 13.9461 7.01899 14.0372 7.0567C14.1282 7.09442 14.2109 7.14969 14.2806
                    7.21937C14.3503 7.28906 14.4056 7.37178 14.4433 7.46283C14.481 7.55387 14.5004
                    7.65145 14.5004 7.75C14.5004 7.84855 14.481 7.94613 14.4433 8.03717C14.4056
                    8.12822 14.3503 8.21094 14.2806 8.28063Z"
                  fill="#69A112"
                />
            </svg>
        );
    }

    renderError(): ReactElement {
        return (
            <svg
              block="NotificationIcon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path
                  d="M10 0.25C8.07164 0.25 6.18657 0.821828 4.58319 1.89317C2.97982 2.96451
                     1.73013 4.48726 0.992179 6.26884C0.254225 8.05042 0.061142 10.0108 0.437348
                     11.9021C0.813554 13.7934 1.74215 15.5307 3.10571 16.8943C4.46928 18.2579
                     6.20656 19.1865 8.09787 19.5627C9.98919 19.9389 11.9496 19.7458 13.7312
                     19.0078C15.5127 18.2699 17.0355 17.0202 18.1068 15.4168C19.1782
                     13.8134 19.75 11.9284 19.75 10C19.7473 7.41498 18.7192 4.93661 16.8913 3.10872C15.0634
                     1.28084 12.585 0.25273 10 0.25ZM13.5306 12.4694C13.6003 12.5391 13.6556 12.6218
                     13.6933 12.7128C13.731 12.8039 13.7504 12.9015 13.7504 13C13.7504 13.0985 13.731
                     13.1961 13.6933 13.2872C13.6556 13.3782 13.6003 13.4609 13.5306 13.5306C13.4609
                     13.6003 13.3782 13.6556 13.2872 13.6933C13.1961 13.731 13.0986 13.7504
                     13 13.7504C12.9015 13.7504 12.8039 13.731 12.7128 13.6933C12.6218 13.6556
                     12.5391 13.6003 12.4694 13.5306L10 11.0603L7.53063 13.5306C7.46095 13.6003
                     7.37822 13.6556 7.28718 13.6933C7.19613 13.731 7.09855 13.7504 7 13.7504C6.90146
                     13.7504 6.80388 13.731 6.71283 13.6933C6.62179 13.6556 6.53906 13.6003
                     6.46938 13.5306C6.3997 13.4609 6.34442 13.3782 6.30671 13.2872C6.269 13.1961 6.24959
                     13.0985 6.24959 13C6.24959 12.9015 6.269 12.8039 6.30671 12.7128C6.34442 12.6218
                     6.3997 12.5391 6.46938 12.4694L8.93969 10L6.46938 7.53063C6.32865 7.38989 6.24959
                     7.19902 6.24959 7C6.24959 6.80098 6.32865 6.61011 6.46938 6.46937C6.61011
                     6.32864 6.80098 6.24958 7 6.24958C7.19903 6.24958 7.3899 6.32864 7.53063
                     6.46937L10 8.93969L12.4694 6.46937C12.5391 6.39969 12.6218 6.34442 12.7128
                     6.3067C12.8039 6.26899 12.9015 6.24958 13 6.24958C13.0986 6.24958 13.1961 6.26899 13.2872
                     6.3067C13.3782 6.34442 13.4609 6.39969 13.5306 6.46937C13.6003 6.53906 13.6556
                     6.62178 13.6933 6.71283C13.731 6.80387 13.7504 6.90145 13.7504 7C13.7504 7.09855
                     13.731 7.19613 13.6933 7.28717C13.6556 7.37822 13.6003 7.46094 13.5306
                     7.53063L11.0603 10L13.5306 12.4694Z"
                  fill="#C42421"
                />
            </svg>
        );
    }

    renderInfo(): ReactElement {
        return (
            <svg
              block="NotificationIcon"
              width="22"
              height="19"
              viewBox="0 0 22 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path
                  d="M21.201 15.6335L13.0026 1.39569C12.7977 1.04687 12.5052 0.757642
                    12.1541 0.556681C11.803 0.35572 11.4055 0.25 11.001 0.25C10.5965
                    0.25 10.199 0.35572 9.84787 0.556681C9.49679 0.757642 9.20431
                    1.04687 8.99944 1.39569L0.801006 15.6335C0.603883 15.9709
                    0.5 16.3546 0.5 16.7454C0.5 17.1361 0.603883 17.5199 0.801006
                    17.8572C1.00325 18.2082 1.29523 18.499 1.64697 18.6998C1.99871
                    18.9006 2.39755 19.0043 2.80257 19.0001H19.1994C19.6041 19.0039
                    20.0026 18.9001 20.354 18.6993C20.7054 18.4985 20.997 18.2079 21.1991 17.8572C21.3965
                    17.52 21.5007 17.1364 21.5011 16.7456C21.5014 16.3549 21.3978 15.9711
                    21.201 15.6335ZM10.251 7.75006C10.251 7.55115 10.33 7.36038 10.4707
                    7.21973C10.6113 7.07908 10.8021 7.00006 11.001 7.00006C11.1999 7.00006
                    11.3907 7.07908 11.5313 7.21973C11.672 7.36038 11.751 7.55115 11.751
                    7.75006V11.5001C11.751 11.699 11.672 11.8897 11.5313 12.0304C11.3907 12.171 11.1999
                    12.2501 11.001 12.2501C10.8021 12.2501 10.6113 12.171 10.4707 12.0304C10.33
                    11.8897 10.251 11.699 10.251 11.5001V7.75006ZM11.001 16.0001C10.7785 16.0001
                    10.561 15.9341 10.376 15.8105C10.191 15.6868 10.0468 15.5111 9.96164 15.3056C9.87649
                    15.1 9.85421 14.8738 9.89762 14.6556C9.94103 14.4374 10.0482 14.2369 10.2055
                    14.0796C10.3628 13.9222 10.5633 13.8151 10.7815 13.7717C10.9998 13.7283 11.226
                    13.7505 11.4315 13.8357C11.6371 13.9208 11.8128 14.065 11.9364 14.25C12.06
                    14.435 12.126 14.6526 12.126 14.8751C12.126 15.1734 12.0075 15.4596 11.7965
                    15.6706C11.5855 15.8815 11.2994 16.0001 11.001 16.0001Z"
                  fill="#EE7F00"
                />
            </svg>
        );
    }

    render(): ReactElement {
        const {type} = this.props;

        switch (type) {
        case NotificationType.INFO:
            return this.renderInfo();
        case NotificationType.ERROR:
            return this.renderError();
        case NotificationType.SUCCESS:
            return this.renderSuccess();
        default:
            return null;
        }
    }
}

export default NotificationIconComponent;
